(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pb-shipping-feature"] && !Shopify.designMode) return;
  try {
    
/* PastéBCN — Autoplay de vídeo gestionado (ahorro de batería + reduced-motion).
   Web Component: connectedCallback re-inicializa solo en shopify:section:load. */
if (!customElements.get('pb-autoplay-video')) {
  class PbAutoplayVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        // Sin reproducción: el vídeo pausado muestra el poster como imagen estática.
        this.video.removeAttribute('autoplay');
        this.video.pause();
        return;
      }

      if (typeof IntersectionObserver === 'undefined') {
        this._safePlay();
        return;
      }

      this._observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this._safePlay();
            else this.video.pause();
          });
        },
        { threshold: 0.25 }
      );
      this._observer.observe(this);
    }

    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect();
        this._observer = null;
      }
    }

    _safePlay() {
      const p = this.video.play();
      if (p && typeof p.catch === 'function') p.catch(() => {});
    }
  }
  customElements.define('pb-autoplay-video', PbAutoplayVideo);
}

  } catch(e) { console.error(e); }
})();
})();
